"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _LiveTicker = _interopRequireDefault(require("./LiveTicker.scss"));

var _MessagingService = _interopRequireDefault(require("../../../KESI2/Services/MessagingService"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _LiveTickerMessage = _interopRequireDefault(require("./LiveTickerMessage"));

var _LiveTickerList = _interopRequireDefault(require("./LiveTickerList"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _LiveTickerSingleChoiceQuestion = _interopRequireDefault(require("./LiveTickerSingleChoiceQuestion"));

var _FeedbackProvider = _interopRequireDefault(require("./FeedbackProvider"));

var _LiveTickerMultipleChoiceQuestion = _interopRequireDefault(require("./LiveTickerMultipleChoiceQuestion"));

var _moment = _interopRequireDefault(require("moment"));

var _LiveTickerLikertScaleQuestion = _interopRequireDefault(require("./LiveTickerLikertScaleQuestion"));

var _LiveTickerRating = _interopRequireDefault(require("./LiveTickerRating"));

var _LiveTickerRatingGroupFeedback = _interopRequireDefault(require("./LiveTickerRatingGroupFeedback"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _LiveTickerLikertGroupFeedback = _interopRequireDefault(require("./LiveTickerLikertGroupFeedback"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var MESSAGE_STATES = {
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
  NOT_CHECKED: 'notChecked'
};

function removeDuplicatesFromHistory(history) {
  return history.filter(function (message) {
    var sameMessages = history.filter(function (m) {
      return m.id === message.id;
    }); // check if there are any newer messages
    // if yes, return false
    // if not return message

    if (sameMessages.length > 1 && sameMessages.some(function (m) {
      return m.dateEdited !== null;
    }) && message.dateEdited === null) {
      return false;
    }

    if (sameMessages.length > 1 && sameMessages.some(function (m) {
      return m.dateCreated && (0, _moment["default"])(m.dateCreated).isAfter((0, _moment["default"])(message.dateCreated));
    })) {
      return false;
    }

    if (sameMessages.length > 1 && sameMessages.some(function (m) {
      return m.dateEdited && (0, _moment["default"])(m.dateEdited).isAfter((0, _moment["default"])(message.dateEdited));
    })) {
      return false;
    }

    return message;
  });
}

function removeRejectedFromHistory(history) {
  return history.filter(function (message) {
    return message.state !== MESSAGE_STATES.REJECTED;
  });
}

var LiveTicker = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(LiveTicker, _DataStoreComponent);

  var _super = _createSuper(LiveTicker);

  function LiveTicker(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, LiveTicker);
    _this = _super.call(this, props);
    _this.state = _objectSpread({
      isConnecting: true,
      connectingError: null,
      userId: null,
      userName: null,
      isExpert: false,
      presenceList: null,
      quotedMessage: null,
      chatActive: true,
      chatFinished: false,
      statusInitialized: false
    }, _this.state);
    _this.channel = null; // will be initialized in connectToChatChannel

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(LiveTicker.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.LIVETICKER_MESSAGES]);
    return _this;
  }

  (0, _createClass2["default"])(LiveTicker, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.connectToLivetickerChannel();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "connectToLivetickerChannel",
    value: function () {
      var _connectToLivetickerChannel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _MessagingService["default"].getChannel(this.props.ablyChannel, true);

              case 3:
                this.channel = _context2.sent;
                _context2.next = 6;
                return (0, _TimeoutHelper.timeout)(200);

              case 6:
                this.setState({
                  isConnecting: false
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error('error connecting to chat channel', _context2.t0);
                this.setState({
                  isConnecting: false,
                  connectingError: (0, _ErrorHelper.getErrorMessage)(_context2.t0)
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function connectToLivetickerChannel() {
        return _connectToLivetickerChannel.apply(this, arguments);
      }

      return connectToLivetickerChannel;
    }()
  }, {
    key: "render",
    value: function render() {
      var channelId = this.props.ablyChannel;
      var messages = [];

      var messageObjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LIVETICKER_MESSAGES);

      console.log('liveticker', messageObjects);

      if (messageObjects && messageObjects[this.props.ablyChannel]) {
        messages = removeDuplicatesFromHistory(messageObjects[this.props.ablyChannel]);
        messages = removeRejectedFromHistory(messages);
      }

      messages.sort(function (content1, content2) {
        if (content1.dateCreated && content2.dateCreated) {
          if (content1.dateCreated < content2.dateCreated) {
            return 1;
          }

          if (content1.dateCreated > content2.dateCreated) {
            return -1;
          }

          return 0;
        }
      });

      if (this.state.isConnecting) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Verbindung wird zu ", channelId, " aufgebaut");
      }

      if (this.state.connectingError) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "Verbindung zu ", channelId, " konnte nicht aufgebaut werden. Grund:", /*#__PURE__*/_react["default"].createElement("p", null, this.state.connectingError));
      }

      var messagesToRender = messages.map(function (message, index) {
        if (index === 0) {
          console.log('last message to render', message);
        }

        if (message.type === 'single-choice-question') {
          return /*#__PURE__*/_react["default"].createElement(_LiveTickerSingleChoiceQuestion["default"], {
            key: message.id,
            id: message.id,
            userId: message.author,
            message: message.html,
            imageLink: message.imageLink,
            dateCreated: message.dateCreated,
            dateEdited: message.dateEdited,
            author: message.author,
            isLatest: index === messages.length - 1,
            isHidden: message.isHidden || false,
            data: message.data,
            active: message.active,
            startTime: message.dateAccepted || message.dateCreated,
            duration: message.duration
          });
        }

        if (message.type === 'multiple-choice-question') {
          return /*#__PURE__*/_react["default"].createElement(_LiveTickerMultipleChoiceQuestion["default"], {
            key: message.id,
            id: message.id,
            userId: message.author,
            message: message.html,
            imageLink: message.imageLink,
            dateCreated: message.dateCreated,
            dateEdited: message.dateEdited,
            author: message.author,
            isLatest: index === messages.length - 1,
            isHidden: message.isHidden || false,
            data: message.data,
            active: message.active,
            startTime: message.dateAccepted || message.dateCreated,
            duration: message.duration
          });
        }

        if (message.type === 'likert-scale-question') {
          return /*#__PURE__*/_react["default"].createElement(_LiveTickerLikertScaleQuestion["default"], {
            key: message.id,
            id: message.id,
            userId: message.author,
            message: message.html,
            imageLink: message.imageLink,
            dateCreated: message.dateCreated,
            dateEdited: message.dateEdited,
            author: message.author,
            isLatest: index === messages.length - 1,
            isHidden: message.isHidden || false,
            data: message.data,
            active: message.active,
            startTime: message.dateAccepted || message.dateCreated,
            duration: message.duration
          });
        }

        if (message.type === 'rating') {
          return /*#__PURE__*/_react["default"].createElement(_LiveTickerRating["default"], {
            key: message.id,
            id: message.id,
            userId: message.author,
            message: message.html,
            imageLink: message.imageLink,
            dateCreated: message.dateCreated,
            dateEdited: message.dateEdited,
            author: message.author,
            isLatest: index === messages.length - 1,
            isHidden: message.isHidden || false,
            data: message.data,
            active: message.active,
            startTime: message.dateAccepted || message.dateCreated,
            duration: message.duration
          });
        }

        if (message.type === 'rating-group-feedback') {
          return /*#__PURE__*/_react["default"].createElement(_LiveTickerRatingGroupFeedback["default"], {
            key: message.id,
            id: message.id,
            userId: message.author,
            message: message.html,
            imageLink: message.imageLink,
            dateCreated: message.dateCreated,
            dateEdited: message.dateEdited,
            author: message.author,
            isLatest: index === messages.length - 1,
            isHidden: message.isHidden || false,
            data: message.data,
            active: message.active,
            startTime: message.dateAccepted || message.dateCreated,
            duration: message.duration,
            messages: messages,
            group: message.group
          });
        }

        if (message.type === 'likert-group-feedback') {
          return /*#__PURE__*/_react["default"].createElement(_LiveTickerLikertGroupFeedback["default"], {
            key: message.id,
            id: message.id,
            userId: message.author,
            message: message.html,
            imageLink: message.imageLink,
            dateCreated: message.dateCreated,
            dateEdited: message.dateEdited,
            author: message.author,
            isLatest: index === messages.length - 1,
            isHidden: message.isHidden || false,
            data: message.data,
            active: message.active,
            startTime: message.dateAccepted || message.dateCreated,
            duration: message.duration,
            messages: messages,
            group: message.group
          });
        }

        return /*#__PURE__*/_react["default"].createElement(_LiveTickerMessage["default"], {
          key: message.id,
          id: message.id,
          userId: message.author,
          message: message.html,
          imageLink: message.imageLink,
          videoId: message.videoId,
          dateCreated: message.dateCreated,
          dateEdited: message.dateEdited,
          author: message.author,
          isLatest: index === messages.length - 1,
          isHidden: message.isHidden || false
        });
      });
      return /*#__PURE__*/_react["default"].createElement(_FeedbackProvider["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        style: this.state.isExpert || !_DeviceInfoHelper["default"].isSafari() ? {} : {
          paddingBottom: '50px'
        },
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTicker["default"].chat : _LiveTicker["default"].chatMobile
      }, _config["default"].showNuggetIcons ? null : this.props.adminActive ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _LiveTicker["default"].alarmContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _LiveTicker["default"].alarmActive
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _LiveTicker["default"].alarmInfo
      }, "Live-Ticker online!")) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _LiveTicker["default"].alarmContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _LiveTicker["default"].alarmInactive
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _LiveTicker["default"].alarmInfo
      }, "Live-Ticker offline")), /*#__PURE__*/_react["default"].createElement(_LiveTickerList["default"], null, messagesToRender.length > 0 ? messagesToRender : 'Keine Nachrichten vorhanden')));
    }
  }]);
  return LiveTicker;
}(_DataStoreComponent2["default"]);

LiveTicker.propTypes = {
  ablyChannel: _propTypes["default"].string.isRequired,
  info: _propTypes["default"].string,
  adminActive: _propTypes["default"].bool
};
var _default = LiveTicker;
exports["default"] = _default;